export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/watercolor_feminine.17c4a00.svg";